<template>
  <div class="">
    <div class="swiper-container" id="qual_swiperIndex">
      <div class="swiper-wrapper">
        <div
          v-for="(item, i) in sliders"
          :key="i"
          class="swiper-slide "
         
        >
          <img :src="item.img" :style="{ width: item.width > item.height ? '12.5rem' : '9.375rem' }" />
          <div :style="{ width: item.width > item.height ? '12.5rem' : '9.375rem',textAlign:'center',color:'#B3B0B0',marginTop:'0.2rem' }">
            {{ item.title }}
          </div>
        </div>
      </div>
      <!-- //换页器 -->
      <!-- <div class="swiper-pagination"></div> -->
      <!-- //前进后退 -->
      <div class="swiper-button-next swiper-button-white"></div>
      <div class="swiper-button-prev swiper-button-white"></div>
      <!-- //滚动条 -->
      <!-- <div class="swiper-scrollbar"></div> -->
    </div>
  </div>
</template>

<script>
import "swiper/css/swiper.css";
import Swiper from "swiper";
import { Lazyload } from 'mint-ui';
var qualSwiper;

let imgBaseUrl =
  "https://dh-policy-bucket.obs.cn-east-3.myhuaweicloud.com/www/";
export default {
  name: "",
  mixins: [],
  components: {},
  props: {},
  data() {
    return {
      sliders:[
      {
          title: "3A诚信经营",
          describe: "3A诚信经营示范单位证书",
          img: imgBaseUrl + "honor1.jpg",
          width: "4252",
          height: "3071",
        },
        {
          title: "计算机软著",
          describe: "计算机软著",
          img: imgBaseUrl + "honor2.jpg",
          width: "509",
          height: "720",
        },
        {
          title: "信息系统安全等级",
          describe: "信息系统安全等级保护备案",
          img: imgBaseUrl + "honor3.jpg",
          width: "1123",
          height: "793",
        },
        {
          title: "高新技术企业",
          describe: "高新技术企业",
          img: imgBaseUrl + "honor4.jpg",
          width: "720",
          height: "508",
        },
        {
          title: "计算机软著",
          describe: "计算机软著",
          img: imgBaseUrl + "honor5.jpg",
          width: "531",
          height: "720",
        },

        {
          title: "3A质量服务",
          describe: "3A质量服务诚信单位",
          img: imgBaseUrl + "honor6.jpg",
          width: "1799",
          height: "2542",
        },
       
        {
          title: "3A诚信经营",
          describe: "高新企业",
          img: imgBaseUrl + "honor8.jpg",
          width: "1799",
          height: "2542",
        },
        {
          title: "计算机软著",
          describe: "计算机软著",
          img: imgBaseUrl + "honor16.png",
          width: "547",
          height: "752",
        },
        {
          title: "计算机软著",
          describe: "计算机软著",
          img: imgBaseUrl + "honor17.jpg",
          width: "2480",
          height: "3360",
        },

        {
          title: "信息安全管理体系",
          describe: "信息安全管理体系",
          img: imgBaseUrl + "honor18.jpg",
          width: "596",
          height: "841",
        },
        {
          title: "信息技术服务体系",
          describe: "信息技术服务体系",
          img: imgBaseUrl + "honor19.jpg",
          width: "596",
          height: "841",
        },
      ],

    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    qualSwiper = new Swiper("#qual_swiperIndex", {
      //配置分页器内容
      loop: true, // 循环模式选项
      // slidesPerView: 1,
      // autoplay: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      allowTouchMove:true,
    });
  },
  methods: {},
};
</script>

<style scoped >


.swiper-slide{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 14.56rem;
}
</style>
